import { Button, ContentCard, Group, Stack } from '@forwardflow/ui-v2'
import { motion } from 'framer-motion'
import cn from 'classnames'
import { PRIMARY_FILTER_OPTIONS } from '@forwardflow/constants/onboarding.constants'
import { useOnboardingStoreV2 } from '@forwardflow/store/onboardingStoreV2'
import { ChevronRightIcon } from '@forwardflow/icons'

export const PrimaryFilter = ({
   setStep,
   selectedPrimaryFilter,
   setSelectedPrimaryFilter,
}: {
   setStep: (step: number) => void
   selectedPrimaryFilter: string | null
   setSelectedPrimaryFilter: (selectedPrimaryFilter: string | null) => void
}) => {
   const { setFirstFilterCriteria } = useOnboardingStoreV2()
   return (
      <Stack>
         <ContentCard className="space-y-4">
            <p className="text-white font-semibold text-lg">
               Which leads do you want Forward Flow to work on first?
            </p>
            <Stack gap={0}>
               <p className="text-white/70 font-medium text-sm">
                  Choose how you'd like to define your target group.
               </p>
               <p className="text-white/70 text-sm">
                  You can start from a specific source, pond, stage, or tag -
                  we’ll tailor outreach accordingly.
               </p>
            </Stack>
            <Stack gap={8}>
               {PRIMARY_FILTER_OPTIONS.map((option) => (
                  <motion.button
                     onClick={() => {
                        if (selectedPrimaryFilter !== option.value) {
                           setFirstFilterCriteria({
                              field: option.value as
                                 | 'source'
                                 | 'stage'
                                 | 'tags'
                                 | 'assigned_pond_id',
                              value: [],
                              logic: 'AND',
                              operator: 'CONTAINS_ANY',
                           })
                        }
                        setStep(2)
                        setSelectedPrimaryFilter(option.value)
                     }}
                     key={option.value}
                     className={cn(
                        'rounded-[8px] p-4 mb-2 flex items-center gap-4 text-left',
                        selectedPrimaryFilter === option.value
                           ? 'bg-[#A684FF]/30'
                           : 'bg-white/5'
                     )}
                  >
                     <Group
                        className="rounded-[8px] bg-[#9F7BFF]/10 w-9 h-9"
                        justify="center"
                        align="center"
                     >
                        {option.icon}
                     </Group>
                     <Stack gap={0}>
                        <p className="text-white/70 font-medium text-lg">
                           {option.label}
                        </p>
                        <p className="text-white text-xs">
                           {option.description}
                        </p>
                     </Stack>
                  </motion.button>
               ))}
            </Stack>
         </ContentCard>
         {selectedPrimaryFilter && (
            <Button
               className="w-full"
               onClick={() => setStep(2)}
               disabled={!selectedPrimaryFilter}
            >
               Continue <ChevronRightIcon width={18} />
            </Button>
         )}
      </Stack>
   )
}
